import {closeContentMenu} from './Project';
import {closeLandingpageMenu} from './LandingPageSwitch';

const activeMainNavItemClass = 'navigationMainItem--active';
const activeMobileMainNavClass = 'header__mobileNav--active';
const activeHeaderSearchClass = 'header__searchbar--active';
const activeFlyoutClass = 'navigationMainItem__flyoutElement--active';
const mobileActiveFlyoutCategoryClass = 'flyout__categories--active';
const pageOverlayActiveClass = 'body--showOverlay';
const mobileFlyoutActiveClass = 'body--showMobileMenu';
const noFlyoutNavElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-navigationMainItemNoFlyout');
const mainNavigationElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-navigationMainItem');
const secondLevelLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-secondaryLink');
const thirdLevelLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-thirdLevelLink');
const flyoutElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-flyoutContent');
const mobileNavigationToggle: HTMLElement | null = document.querySelector('.js-mobileNavToggle');
const searchToggle: HTMLElement | null = document.querySelector('.js-SearchToggle');
const mobileCategoryTitleElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categoryItem');
const mobileCategoryBackLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categoryBackLink');
const mobileCategorySubElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-categorySubItems');
const mobileFirstLevelLinkElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-firstLevelLink');
const landingpageHeader = document.querySelector('.js-landingpageSwitchHeader');
const landingPageSection = document.querySelector('.js-landingPageSection');
const landingpage = document.querySelector('.js-landingpageSwitch');

export function initMainNavigationHandler() {
  mainNavigationElements.forEach((mainNavItem) => {
    mainNavItem.addEventListener('mousedown', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      if (mainNavItem.parentElement?.classList.contains(activeMainNavItemClass)) {
        closeAllFlyoutElements();
        closeMobileMenu();
      } else {
        closeOrOpenFlyout(mainNavItem);
      }
    });

    mainNavItem.addEventListener('focus', (event) => {
      closeOrOpenFlyout(mainNavItem);
    });

    /* close flyout when tabbed through it */
    mainNavItem.addEventListener('blur', (event) => {
      const relatedTarget: HTMLElement | null = event.relatedTarget as HTMLElement;
      if (!relatedTarget) {
        return;
      }
      if (!relatedTarget.classList.contains('js-preventCloseFlyout')) {
        closeAllFlyoutElements();
        closeMobileMenu();
      }
    });
  });

  searchToggle?.addEventListener('focus', () => {
    closeAllFlyoutElements();
    closeMobileMenu();
    toggleSearchFlyout();
  });

  /* close search flyout */
  searchToggle?.addEventListener('blur', (event) => {
    const relatedTarget: HTMLElement | null = event.relatedTarget as HTMLElement;
    if (relatedTarget?.classList.contains('js-calendar')) {
      toggleSearchFlyout();
    }
  });

  /* toggle accordions on enter */
  const accordionElements: NodeListOf<HTMLDetailsElement> = document.querySelectorAll('.js-accordion');
  accordionElements.forEach((accordionElement) => {
    accordionElement.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        accordionElement.toggleAttribute('open');
      }
    });
  });

  /* close navigation on escape key or click on page overlay */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllFlyoutElements();
      closeMobileMenu();
      closeSearchFlyout();
    }
  });

  // click on darkened content in background
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (target.classList.contains(pageOverlayActiveClass)) {
      closeAllFlyoutElements();
      closeMobileMenu();
      closeContentMenu();
      closeLandingpageMenu();
      landingpageHeader?.classList.remove('landingPageSwitch--active');
    }
  });

  /* mobile navigation */
  mobileNavigationToggle?.addEventListener('click', () => {
    if (mobileNavigationToggle?.classList.contains(activeMobileMainNavClass)) {
      mobileNavigationToggle?.classList.remove(activeMobileMainNavClass);
      closeMobileMenu(0);
      closeAllFlyoutElements();
      landingPageSection?.classList.remove('landingpageSection--active');
      landingpage?.classList.remove('landingPageSwitch--active');
      landingpageHeader?.classList.remove('landingPageSwitch--active');
    } else {
      mobileNavigationToggle?.classList.add(activeMobileMainNavClass);
      showMobileMenu();
      closeContentMenu();
    }
  });

  mobileCategoryTitleElements.forEach((categoryTitle) => {
    categoryTitle.addEventListener('click', () => {
      const secondLevelWrapper = categoryTitle.parentElement?.querySelector('.js-categorySubItems');
      secondLevelWrapper?.classList.add('secondaryItemsWrapper--active');
      categoryTitle.closest('.js-flyoutCategories')?.classList.add(mobileActiveFlyoutCategoryClass);
    });
  });

  mobileFirstLevelLinkElements.forEach((firstLevelLink) => {
    firstLevelLink.addEventListener('click', () => {
      closeAllFlyoutElements();
    });
  });

  mobileCategoryBackLinkElements.forEach((categoryBackLink) => {
    categoryBackLink.addEventListener('click', () => {
      closeAllCategoryElements();
    });
  });

  setActiveClasses();
}

export function initSearchHeader() {
  /* flyout searchbar */
  searchToggle?.addEventListener('mousedown', (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    toggleSearchFlyout();
  });
}

function toggleSearchFlyout() {
  if (document.body.classList.contains(activeHeaderSearchClass)) {
    closeSearchFlyout();
  } else {
    document.body.classList.add(activeHeaderSearchClass);
  }
}

function closeSearchFlyout() {
  document.body.classList.remove(activeHeaderSearchClass);
}

function closeOrOpenFlyout(mainNavItem: HTMLElement) {
  const flyoutElement: HTMLElement | null | undefined = mainNavItem.parentElement?.querySelector('.js-flyoutContent');
  if (!flyoutElement) {
    return;
  }
  if (flyoutElement.classList.contains(activeFlyoutClass)) {
    closeAllFlyoutElements();
    closeMobileMenu();
  } else {
    closeAllFlyoutElements();
    flyoutElement.classList.add(activeFlyoutClass);
    mainNavItem.parentElement?.classList.add(activeMainNavItemClass);
    showMobileMenu();
    closeContentMenu();
  }
}

function closeAllFlyoutElements() {
  closeAllCategoryElements();
  flyoutElements.forEach((flyoutElement) => {
    flyoutElement.classList.remove(activeFlyoutClass);
  });
  mainNavigationElements.forEach((mainNavItem) => {
    mainNavItem.parentElement?.classList.remove(activeMainNavItemClass);
  });
}

function closeAllCategoryElements() {
  mobileCategorySubElements.forEach((categorySubElement) => {
    categorySubElement.classList.remove('secondaryItemsWrapper--active');
    categorySubElement.closest('.js-flyoutCategories')?.classList.remove(mobileActiveFlyoutCategoryClass);
  });
}

function setActiveClasses() {
  const activeSubMenuClass = 'subMenuItem--active';
  const secondaryActiveClass = 'secondaryItem--active';
  const subMenuElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-submenuItem');
  let pageId = '';

  /* get current page id */
  document.body.classList.forEach((bodyClass) => {
    if (bodyClass.includes('pid-')) {
      pageId = bodyClass.replace('pid-', '');
    }
  });

  noFlyoutNavElements.forEach((mainNavItem) => {
    if (mainNavItem.dataset.pageId === pageId) {
      mainNavItem.parentElement?.classList.add(activeSubMenuClass);
    }
  });

  if (subMenuElements.length === 0) {
    return;
  }

  document.documentElement.classList.add('subMenuActive');

  subMenuElements.forEach((subMenuItem) => {
    const ids = subMenuItem.dataset.pageIds?.split(',');
    if (ids?.includes(pageId)) {
      let parentId = subMenuItem.dataset.parentId;
      subMenuItem.classList.add(activeSubMenuClass);

      /* find parent and add active class */
      mainNavigationElements.forEach((mainNavItem) => {
        if (mainNavItem.dataset.pageId === parentId) {
          mainNavItem.parentElement?.classList.add(activeSubMenuClass);
        }
      });

      secondLevelLinkElements.forEach((secondLevelLink) => {
        if (secondLevelLink.dataset.pageId === pageId) {
          secondLevelLink.classList.add(secondaryActiveClass);
        }
      });

      thirdLevelLinkElements.forEach((thirdLevelLink) => {
        if (thirdLevelLink.dataset.pageId === pageId) {
          thirdLevelLink.classList.add('thirdLevelItem--active');
          /* open accordion */
          thirdLevelLink.closest('.js-accordion')?.setAttribute('open', '');
          thirdLevelLink.closest('.js-secondaryLink')?.classList.add(secondaryActiveClass);
        }
      });
    }
  });
}

export function showPageOverlay() {
  document.body.classList.add(pageOverlayActiveClass);
}

export function showMobileMenu() {
  showPageOverlay();
  document.body.classList.add(mobileFlyoutActiveClass);
}

export function closePageOverlay(delay: number = 250) {
  window.setTimeout(
    () => {
      document.body.classList.remove(pageOverlayActiveClass);
    },
    delay,
  );
}

export function closeMobileMenu(delay: number = 250) {
  document.body.classList.remove(mobileFlyoutActiveClass);
  closePageOverlay(delay);
}

export function initLanguageNav() {
  const languageSwitches = document.querySelectorAll('.js-languageSwitch');
  languageSwitches.forEach((languageSwitch) => {

    if (!languageSwitch) {
      return;
    }
    const openClass = 'languageSwitch--open';
    languageSwitch.addEventListener('click', (event) => {
      const target = event.target as HTMLElement;
      if (!languageSwitch.parentElement || !target) {
        return;
      }
      if (!languageSwitch.parentElement.classList.contains(openClass)) {
        // avoid problems with "close" click watcher
        window.setTimeout(
          () => {
            if (!languageSwitch.parentElement) {
              return;
            }
            languageSwitch.parentElement.classList.add(openClass);
          },
          50,
        );
      }
    });

    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      const parent = languageSwitch.parentElement as HTMLElement;
      if (!target || !parent) {
        return;
      }

      if (parent.classList.contains(openClass) &&
        (target.closest('.languageSwitch__list') === null || target.closest('.js-languageSwitch') !== null)) {
        parent.classList.remove(openClass);
      }
    });
  });
}
